import * as AssessmentApi from '../api/assessmentApi';
export const RECEIVE_FILTERS = 'RECEIVE_FILTERS';

export const receiveFilters = (filters) => ({
    type: RECEIVE_FILTERS,
    filters
});

export const fetchAllFilters = (assessmentName, versionId) => dispatch => {
    return AssessmentApi.fetchAssessment(assessmentName, versionId)
        .then(res => {
            const filters = extractAllFilters(res.data);
            return dispatch(receiveFilters(filters));
        });
};

const extractAllFilters = (data) => {
    const { prompts, additionalFilters } = data;

    let filters = Object.values(prompts)
        .map(prompt => parseFilterInfo(prompt))
        .flat();
    return filters.concat(additionalFilters);
}

const parseFilterInfo = (prompt) => {
    return {
        filterCategory: prompt.filterCategory,
        filters: prompt.filters,
        maxSelection: prompt.maxSelection,
        minSelection: prompt.minSelection
    }
}